import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneInputComponent = ({ phone, setPhone, errors, setErrors }) => {
  const handlePhoneChange = (value, data, event, formattedValue) => {
    // Update phone state
    setPhone(value);

    // Clear phone error if it exists
    if (errors && errors.phone) {
      setErrors({ ...errors, phone: '' });
    }
  };

  return (
    <PhoneInput
      country={"us"}
      value={phone}
      onChange={handlePhoneChange}
      inputStyle={{
        borderColor: "gray.300",
        background: "white",
        width: "100%",
        outline: "none",
        boxShadow: "none",
      }}
      containerStyle={{
        width: "100%"
      }}
    />
  );
};

export default PhoneInputComponent;




// import React from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import "../../styles/phone-input-overrides.css"; // ✅ Import your override file

// const PhoneInputComponent = ({ phone, setPhone }) => {
//   return (
//     <PhoneInput
//       country={"us"}
//       value={phone}
//       onChange={setPhone}
//       inputStyle={{
//         borderColor: "gray.300",
//         background: "none",
//         width: "100%",
//         borderRadius: "9999px",
//         outline: "none",
//         boxShadow: "none",
//       }}
//       containerStyle={{
//         width: "100%",
//       }}
//       buttonStyle={{
//         borderRadius: "9999px 0 0 9999px",
//         borderColor: "gray.300",
//         background: "none",
//         borderRight: "none",
//         height: "35px",
//         // outline: "none",
//         boxShadow: "none",
//         outline: "gray.300",
//         _active: "gray.300",
//         _focus: "gray.300",
//       }}
//     />
//   );
// };

// export default PhoneInputComponent;
